require('../../modules/es6.string.from-code-point');
module.exports = require('../../modules/_core').String.fromCodePoint;



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/fn/string/from-code-point.js